<template>
  <b-container fluid v-if="entry.page.template === null || (entry.page.template && entry.page.template.name)">
    <FontPicker api-key="AIzaSyDMUTfiI1h9cPWCgvzwXnTVhSAMd6OqGDM" :active-font="site.style.title_font.replace(/'/g, '')" hidden></FontPicker>
    <FontPicker api-key="AIzaSyDMUTfiI1h9cPWCgvzwXnTVhSAMd6OqGDM" :active-font="site.style.body_font.replace(/'/g, '')" hidden></FontPicker>

    <PageEditor :entry='entry' :site="site" :entries="entries" :editing_content="editing_content" :editing_block="editing_block"></PageEditor>

    <head v-html="styles"></head>
    <b-row v-for="(hydrated_block, $index) in hydrated_blocks" :key="$index" v-html="hydrated_block.html" @click="edit_block(hydrated_block.block)"></b-row>
    <b-row v-html="block_footer"></b-row>

    <b-container class="new_section card" v-if="can_add_blocks">
      <h3 class="new_section_h">What Would You Like to Add Next?</h3>
      <p class="new_section_p">Add your next website block. Once you're finished creating you can publish or download your website.</p>
      <b-card-group deck class="justify-content-center">
        <b-card @click="add_section('text')" class='section_card'>
          <h3 class="text-primary"><i class="fad fa-align-center"></i></h3>
          <h5>Text</h5>
        </b-card>

        <b-card @click="add_section('faqs')" class='section_card'>
          <h3 class="text-primary"><i class="fad fa-question"></i></h3>
          <h5>FAQs</h5>
        </b-card>

        <b-card @click="add_section('awards')" class='section_card'>
          <h3 class="text-primary"><i class="fad fa-trophy"></i></h3>
          <h5>Awards</h5>
        </b-card>

        <b-card @click="add_section('testimonials')" class='section_card'>
          <h3 class="text-primary"><i class="fad fa-bullhorn"></i></h3>
          <h5>Testimonials</h5>
        </b-card>

        <b-card @click="add_section('services')" class='section_card'>
          <h3 class="text-primary"><i class="fad fa-concierge-bell"></i></h3>
          <h5>Services</h5>
        </b-card>

        <!-- <b-card @click="add_section('article')" class='section_card'>
          <h3><i class="far fa-newspaper"></i></h3>
          <h5>Article</h5>
        </b-card> -->

        <b-card @click="add_section('features')" class='section_card'>
          <h3 class="text-primary"><i class="fad fa-star"></i></h3>
          <h5>Features</h5>
        </b-card>

        <!-- <b-card @click="add_section('checklist')" class='section_card'>
          <h3 class="text-primary"><i class="fad fa-check"></i></h3>
          <h5>Checklist</h5>
        </b-card> -->

        <b-card @click="add_section('cta')" class='section_card'>
          <h3 class="text-primary"><i class="fad fa-location"></i></h3>
          <h5>Call to action</h5>
        </b-card>

        <b-card @click="add_section('form')" class='section_card'>
          <h3 class="text-primary"><i class="fad fa-keyboard"></i></h3>
          <h5>Form</h5>
        </b-card>

        <b-card @click="add_section('blogs')" class='section_card'>
          <h3 class="text-primary"><i class="fad fa-newspaper"></i></h3>
          <h5>Blogs</h5>
        </b-card>
      </b-card-group>
    </b-container>
  </b-container>
</template>

<script>
import {db, serverTimestamp, FieldValue} from '@/main.js'
import Handlebars from 'handlebars'

import PageEditor from "@/components/PageEditor.vue"

import BLOCKS from "@/../functions/shared/blocks.js"
import STYLES from "@/../functions/shared/styles.js"
import FontPicker from 'font-picker-vue'

Handlebars.registerHelper('inArray', function(haystack, needle, options) {
   needle = Handlebars.escapeExpression(needle)
   haystack = Handlebars.escapeExpression(haystack)
   return (haystack.indexOf(needle) > -1) ? options.fn(this) : options.inverse(this)
})

Handlebars.registerHelper('eq', function(haystack, needle, options) {
   needle = Handlebars.escapeExpression(needle)
   haystack = Handlebars.escapeExpression(haystack)
   return (haystack === needle) ? options.fn(this) : options.inverse(this)
})

function capitalise(s) {
  if (typeof s !== 'string') return ''
  return s.charAt(0).toUpperCase() + s.slice(1)
}

export default {
  name: 'entry_page',
  props: ['site', 'entry', 'entries'],
  components: {PageEditor, FontPicker},
  data() {
    return {
      editing_content: {},
      editing_block: {},
      menu: [
        {href: {name: 'entries'}, icon: 'fas fa-chevron-left'},
        {href: {name: 'site_edit'}, title: 'Settings', icon: 'fa fa-cog'},
      ]
    }
  },
  computed: {
    block_footer() {
      let template = Handlebars.compile(BLOCKS['footer'].html)
      return template({site_name: this.site.name, footer: this.site.footer})
    },
    styles() {
      let css = `
      :root {
        --primary-background-colour: ${this.site.colour.primary_background};
        --secondary-background-colour: ${this.site.colour.secondary_background};
        --primary-text-colour: ${this.site.colour.primary_text};
        --secondary-text-colour: ${this.site.colour.secondary_text};
        --title-font: ${this.site.style.title_font};
        --title-weight: ${this.site.style.title_weight};
        --body-font: ${this.site.style.body_font};
      }
      ${STYLES.css}`

      return `<style>${css}</style>`
    },
    can_add_blocks() {
      if (this.entry.page.template) {
        return false
      } else {
        return true
      }
    },
    hydrated_blocks() {
      let hydrated_blocks = []

      this.editing_content // Used to trigger recomputation

      let blocks = []
      if (this.entry.page.template) {
        blocks = this.entry.page.template.page.blocks
      } else {
        blocks = this.entry.page.blocks
      }

      let links = []
      let collections = {}
      let site_home
      for (let entry of this.entries) {
        if (entry.page && entry.page.slug == 'index') {
          site_home = `site/${this.site.id}/entries/${entry.id}/page`
        }
        if (!entry.template && entry.types && entry.types.indexOf('page') > -1 && entry.page.slug != 'index') {

          if (entry.collection === 'blogs') {
            continue
          } else if (entry.collection === 'singles') {
            links.push({name: entry.name, slug: `site/${this.site.id}/entries/${entry.id}/page`})
          } else {
            if (!collections[entry.collection]) {
              collections[entry.collection] = []
            }
            collections[entry.collection].push(entry)
          }
        }
      }

      for (let collection in collections) {
        let sub_links = []
        for (let entry of collections[collection]) {
          sub_links.push({name: entry.name, slug: `site/${this.site.id}/entries/${entry.id}/page`})
        }
        links.push({name: capitalise(collection), sub_links: sub_links})
      }

      for (let block of blocks) {
        let content = JSON.parse(JSON.stringify(this.entry.page.blocks_content[block.id] || {}))

        for (let key in content) {
          if (key[0] === '_') { // Suck in data

            if (key === '_form') {
              content[key.substr(1)] = null

              if (content[key]) {
                content[key.substr(1)] = this.get_entry_block(content[key])
              }
            } else {
              content[key.substr(1)] = []
              if (content[key].length === 0) {
                content[key.substr(1)] = this.get_all_entry_block(key.substr(1))
              } else {
                for (let i in content[key]) {
                  content[key.substr(1)][i] = this.get_entry_block(content[key][i])
                }
              }
            }
          }
        }

        content['site_home'] = site_home
        content['footer'] = this.site.footer
        content['site_name'] = this.site.name
        content['links'] = links
        content['logo_image'] = this.site.logo.image

        let template = Handlebars.compile(BLOCKS[block.type].html)
        let html = template(content)
        html = html.replace('.webp" type="image/webp', '')
        hydrated_blocks.push({html: html, block: block})
      }

      return hydrated_blocks
    }
  },
  watch: {
    'entry.page.template.page.blocks': function(blocks) {
      for (let block of blocks) {
        this.default_block_content(block)
      }
    }
  },
  methods: {
    default_block_content(block) {
      if (!this.entry.page.blocks_content[block.id]) {
        if (this.entry.page.template && this.entry.page.template.page.blocks_content[block.id]) {
          this.entry.page.blocks_content[block.id] = this.entry.page.template.page.blocks_content[block.id]
          return
        }

        this.entry.page.blocks_content[block.id] = {id: block.id}

        if (block.type === 'hero') {
          this.entry.page.blocks_content[block.id].header = "Hero"
          this.entry.page.blocks_content[block.id].sub_heading = "Your subheading goes here"
          this.entry.page.blocks_content[block.id].action = "Get started"
          this.entry.page.blocks_content[block.id].link = "#"
          this.entry.page.blocks_content[block.id].text_colour = "light"
        }
        if (block.type === 'awards') {
          this.entry.page.blocks_content[block.id].header = "Awards"
          this.entry.page.blocks_content[block.id].sub_heading = "Our quality has been noticed."
          this.entry.page.blocks_content[block.id]._awards = []
        }
        if (block.type === 'faqs') {
          this.entry.page.blocks_content[block.id].header = "Have any questions?"
          this.entry.page.blocks_content[block.id].sub_heading = "Our dedicated faq section is full of commonly asked questions, If you don’t find what you’re looking for you can contact us using the button below."
          this.entry.page.blocks_content[block.id].faqs = [{question: 'First customer question', answer: 'This is the answer to the customers question. It can be as long or as short as you need.'}, {question: 'Another harder customer question', answer: 'This is the answer to the customers question. It can be as long or as short as you need.'}, {question: 'A final question', answer: 'This is the answer to the customers question. It can be as long or as short as you need.'}]
        }
        if (block.type === 'testimonials') {
          this.entry.page.blocks_content[block.id].header = "What customers are saying..."
          this.entry.page.blocks_content[block.id].sub_heading = "Loved by our customers"
          this.entry.page.blocks_content[block.id]._testimonials = []
        }
        if (block.type === 'services') {
          this.entry.page.blocks_content[block.id].header = "Services"
          this.entry.page.blocks_content[block.id].sub_heading = "We cover a wide range of services to suit your needs."
          this.entry.page.blocks_content[block.id]._services = []
        }
        if (block.type === 'article') {
          this.entry.page.blocks_content[block.id].header = "Article header"
          this.entry.page.blocks_content[block.id].text = "This is my article body"
        }
        if (block.type === 'features') {
          this.entry.page.blocks_content[block.id].header = "Features"
          this.entry.page.blocks_content[block.id].sub_heading = "Our awesome features"
          this.entry.page.blocks_content[block.id].features = [{header: 'First feature', description: 'Feature description to get your customers excited!', icon: 'https://static.thenounproject.com/png/308-200.png'}, {header: 'Another feature', description: 'Feature description to get your customers excited!', icon: 'https://static.thenounproject.com/png/308-200.png'}, {header: 'Last feature', description: 'Feature description to get your customers excited!', icon: 'https://static.thenounproject.com/png/308-200.png'}]
        }
        if (block.type === 'checklist') {
          this.entry.page.blocks_content[block.id].header = "Checklist"
          this.entry.page.blocks_content[block.id].sub_heading = "Do these things!"
          this.entry.page.blocks_content[block.id].checklist = [{item: 'First thing'}, {item: 'Another thing to do'}, {item: 'Last thing'}]
        }
        if (block.type === 'cta') {
          this.entry.page.blocks_content[block.id].header = "Call to action"
          this.entry.page.blocks_content[block.id].sub_heading = "If you think this text is convincing then click here!"
          this.entry.page.blocks_content[block.id].action = "Get started"
          this.entry.page.blocks_content[block.id].link = "#"
          this.entry.page.blocks_content[block.id].text_colour = "dark"
        }
        if (block.type === 'blogs') {
          this.entry.page.blocks_content[block.id].header = "Blogs"
          this.entry.page.blocks_content[block.id].sub_heading = "View the latest our blogs"
          this.entry.page.blocks_content[block.id]._blogs = []
        }
        if (block.type === 'text') {
          this.entry.page.blocks_content[block.id].header = "What we do"
          this.entry.page.blocks_content[block.id].sub_heading = "What makes us who we are."
          this.entry.page.blocks_content[block.id].text = "Just some text to tell the customer something. It can be as long or as short as needed. But should be kept quite short."
          this.entry.page.blocks_content[block.id].text_colour = "dark"
        }
        if (block.type === 'form') {
          this.entry.page.blocks_content[block.id]._form = this.get_default_form_block() || null // TODO
        }
      }
    },
    get_all_entry_block(key) {
      let entries = []
      for (let entry of this.entries) {
        if (!entry.template && entry.collection === key) {
          entry.block.content.name = entry.name
          entry.block.content.entry = entry
          entry.block.content.slug = `site/${this.site.id}/entries/${entry.id}/page`
          entries.push(entry.block.content)
        }
      }

      return entries
    },
    get_entry_block(id) {
      for (let entry of this.entries) {
        if (entry.id === id) {
          entry.block.content.name = entry.name
          entry.block.content.entry = entry
          entry.block.content.slug = `site/${this.site.id}/entries/${entry.id}/page`

          return entry.block.content
        }
      }
    },
    get_default_form_block() {
      for (let entry of this.entries) {
        if (entry.collection === 'forms') {
          return entry.id
        }
      }
    },
    edit_block(block) {
      this.editing_content = JSON.parse(JSON.stringify(this.entry.page.blocks_content[block.id] || {id: block.id}))
      this.editing_block = block

      this.$bvModal.show(`modal-edit-editor`)
    },
    async add_section(type) {
      let new_block = {type: type, id: db.collection('random').doc().id}
      this.entry.page.blocks.push(new_block)

      this.default_block_content(new_block)

      await db.collection('site').doc(this.$route.params.site_id).collection('entry').doc(this.$route.params.id).update({
        'page.blocks': this.entry.page.blocks,
        'page.blocks_content': this.entry.page.blocks_content
      })

      await db.collection('deploy_queue').doc(this.site.id).set({updated: serverTimestamp(), update_count: FieldValue.increment(1)}, {merge: true})
    }
  }
}
</script>

<style>

.entry-container {
  padding-left: 50px;
}

.browser-nav {
  display: inline;
}

.browser-dot {
  height: 12px;
  width: 12px;
  background-color: #bbb;
  border-radius: 50%;
  display: inline-block;
  margin-right: 6px;
}

.browser-container {
  border: 1px solid #AAA;
  border-radius: 4px;
  /* box-shadow: 0 1px 2px 0 rgba(60,64,67,.3), 0 1px 3px 1px rgba(60,64,67,.15); */
}

.browser-top {
  padding: 10px;
  /* background: #f1f1f1; */
  /* border-top-left-radius: 4px; */
  /* border-top-right-radius: 4px; */
}

.browser-content {
  padding-left: 15px;
  padding-right: 15px;
  background: white;
}

.new_section {
  background: #f5f7f9;
  text-align: center;
  padding: 2em;
  max-width: 600px !important;
  margin-top: 2em;
  margin-bottom: 2em;
}

.section_card {
  text-align: center;
  min-width: 10em !important;
  max-width: 10em !important;
  margin-bottom: 1em !important;
  color: #335dea;
}

.section_card:hover {
  cursor: pointer;
  background-color: #edf0fd;
}

.new_section_p, .new_section_h {
  font-family: "Roboto", sans-serif !important;
  letter-spacing: .25px;
  color: #476282 !important;
}

</style>
